import React from "react";
import ImportExport from "./ImportExport";

export default function ExportWorkspace(props) {
  return <ImportExport {...props} mode="export" />;
}
